"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  FormField: true
};
exports.default = exports.FormField = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _ValidationOverlay = require("../Forms/_ValidationOverlay");
var _Icon = require("../Icon/Icon");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useFocusWithin = require("../utils/_useFocusWithin");
var _constants = require("../utils/constants");
var _isHighContrast = _interopRequireDefault(require("../utils/isHighContrast"));
var _useDebouncedState = require("../utils/useDebouncedState");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _FormFieldDecorator = require("./_FormFieldDecorator");
var _FormField = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./FormField.css") : void 0);
var _FormField2 = require("./_FormField.types");
Object.keys(_FormField2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormField2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormField2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-form-field';
const HEADING_DECORATOR_TYPES = ['headingStart', 'headingEnd', 'label'];
const FormField = exports.FormField = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  var _a, _b, _c;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(FormField, _props)) : _props;
  const {
      tailContainerProps,
      allowReadonlyRequired,
      className,
      controlContainerProps,
      decorators,
      disabled,
      enableScreenReaderStatus,
      headingProps,
      helpText,
      helpTextProps,
      hideValidationMessage,
      screenReaderOnlyLabel,
      id,
      inputDescribedby,
      inputId,
      label,
      labelProps,
      layout = 'vertical',
      readOnly,
      renderInput,
      inputProps,
      required,
      screenReaderMessage,
      shrinkWrap,
      validationMessage,
      controlProps,
      controlRef,
      canTruncate,
      noTruncationOnFocus,
      type,
      validationOverlayProps,
      describeControl
    } = props,
    otherProps = __rest(props, ["tailContainerProps", "allowReadonlyRequired", "className", "controlContainerProps", "decorators", "disabled", "enableScreenReaderStatus", "headingProps", "helpText", "helpTextProps", "hideValidationMessage", "screenReaderOnlyLabel", "id", "inputDescribedby", "inputId", "label", "labelProps", "layout", "readOnly", "renderInput", "inputProps", "required", "screenReaderMessage", "shrinkWrap", "validationMessage", "controlProps", "controlRef", "canTruncate", "noTruncationOnFocus", "type", "validationOverlayProps", "describeControl"]);
  const isHighContrastTheme = (0, _isHighContrast.default)();
  const formFieldRef = (0, _react.useRef)(null);
  const mergedRef = (0, _reactMergeRefs.default)([formFieldRef, ref]);
  const {
    isFocused
  } = (0, _useFocusWithin.useFocusWithin)({
    targetElement: formFieldRef.current
  });
  const classnames = _bind.default.bind(_FormField.default);
  const [showValidation, setShowValidation] = (0, _react.useState)(false);
  let componentId = (0, _useUniqueId.default)();
  if (id) componentId = id;
  let helpTextId = (0, _useUniqueId.default)();
  if (helpTextProps === null || helpTextProps === void 0 ? void 0 : helpTextProps.id) helpTextId = helpTextProps.id;
  const internalControlRef = (0, _react.useRef)({});
  const doDecoratorsExist = position => _react.default.Children.count(decorators === null || decorators === void 0 ? void 0 : decorators[position]) > 0;
  const isInfoIcon = state => _constants.ALLOWED_INFO_ICONS.includes(state);
  const classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, className, {
    [`${CSS_BLOCK}--disabled`]: disabled,
    [`${CSS_BLOCK}--read-only`]: readOnly && !disabled,
    [`${CSS_BLOCK}--high-contrast`]: isHighContrastTheme,
    [`${CSS_BLOCK}--${isInfoIcon(validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state) ? 'info' : validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state}`]: !!validationMessage,
    [`${CSS_BLOCK}--shrink-wrap`]: shrinkWrap,
    [`${CSS_BLOCK}--${layout}`]: layout !== 'vertical'
  });
  const _d = controlProps || {},
    {
      className: controlClassName,
      overrideControlClasses
    } = _d,
    otherControlProps = __rest(_d, ["className", "overrideControlClasses"]);
  const controlClasses = classnames(controlClassName, {
    [`${_constants.CSS_PREFIX}`]: !overrideControlClasses,
    [`${CSS_BLOCK}__control`]: !overrideControlClasses,
    [`${CSS_BLOCK}__control--afterInput`]: !overrideControlClasses && doDecoratorsExist('afterInput')
  });
  const _e = controlContainerProps || {},
    {
      className: controlContainerClassName,
      overrideControlContainerClasses
    } = _e,
    otherControlContainerProps = __rest(_e, ["className", "overrideControlContainerClasses"]);
  const controlContainerClasses = classnames(controlContainerClassName, {
    [`${_constants.CSS_PREFIX}`]: !overrideControlContainerClasses,
    [`${CSS_BLOCK}__control-container`]: !overrideControlContainerClasses
  });
  const headingClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__heading`, headingProps === null || headingProps === void 0 ? void 0 : headingProps.className);
  const labelClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__label`, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className, {
    [`${CSS_BLOCK}__label--screen-reader-only`]: screenReaderOnlyLabel
  });
  const inputClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__input`, {
    [`${CSS_BLOCK}__input--truncated`]: type !== 'password' && canTruncate && (!isFocused || readOnly || disabled || !noTruncationOnFocus),
    [`${CSS_BLOCK}__canTruncate`]: canTruncate
  });
  const helpClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__help`, helpTextProps === null || helpTextProps === void 0 ? void 0 : helpTextProps.className);
  const inputStartId = (0, _useUniqueId.default)();
  const inputEndId = (0, _useUniqueId.default)();
  const castArray = args => Array.isArray(args) ? args : [args];
  const generateDescribedby = () => {
    const totalIds = [];
    if (inputDescribedby) {
      if (Array.isArray(inputDescribedby)) {
        totalIds.push({
          name: 'consumerId',
          value: inputDescribedby.join(' ')
        });
      } else totalIds.push({
        name: 'consumerId',
        value: inputDescribedby
      });
    }
    if (decorators === null || decorators === void 0 ? void 0 : decorators.inputStart) {
      const inputStartArray = castArray(decorators.inputStart);
      if (Array.isArray(inputStartArray)) {
        inputStartArray.forEach(decorator => {
          if (! /*#__PURE__*/_react.default.isValidElement(decorator)) {
            totalIds.push({
              name: 'inputStart',
              value: inputStartId
            });
          }
        });
      }
    }
    if (decorators === null || decorators === void 0 ? void 0 : decorators.inputEnd) {
      const inputEndArray = castArray(decorators.inputEnd);
      if (Array.isArray(inputEndArray)) {
        inputEndArray.forEach(decorator => {
          if (! /*#__PURE__*/_react.default.isValidElement(decorator)) {
            totalIds.push({
              name: 'inputEnd',
              value: inputEndId
            });
          }
        });
      }
    }
    if (helpText) {
      totalIds.push({
        name: 'newHelpTextId',
        value: helpTextId
      });
    }
    return totalIds;
  };
  const ariaDescribedby = generateDescribedby();
  const renderDecorators = position => {
    if (!(decorators === null || decorators === void 0 ? void 0 : decorators[position])) return null;
    const isHeadingDecorator = HEADING_DECORATOR_TYPES.includes(position);
    const parsedDecoratorId = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.filter(idObj => (idObj === null || idObj === void 0 ? void 0 : idObj.name) === position);
    const isInput = position === 'inputStart' || position === 'inputEnd';
    return _react.default.Children.map(decorators === null || decorators === void 0 ? void 0 : decorators[position], (decorator, index) => {
      var _a, _b, _c, _d;
      return /*#__PURE__*/_react.default.createElement(_FormFieldDecorator.FormFieldDecorator, {
        className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__decorator`, {
          [`${CSS_BLOCK}__text-decorator`]: isInput && ! /*#__PURE__*/_react.default.isValidElement(decorator),
          [`${CSS_BLOCK}__input-decorator`]: isInput && /*#__PURE__*/_react.default.isValidElement(decorator),
          [`${CSS_BLOCK}__heading-decorator`]: isHeadingDecorator
        }),
        decoratorId: (_a = parsedDecoratorId === null || parsedDecoratorId === void 0 ? void 0 : parsedDecoratorId[index]) === null || _a === void 0 ? void 0 : _a.value,
        disabled: disabled,
        position: position,
        readOnly: readOnly,
        showInReadOnlyMode: isInput && (! /*#__PURE__*/_react.default.isValidElement(decorator) || typeof decorator.type !== 'string' && ((_b = decorator === null || decorator === void 0 ? void 0 : decorator.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'Icon' || ((_c = decorator === null || decorator === void 0 ? void 0 : decorator.type) === null || _c === void 0 ? void 0 : _c.displayName) === 'MultiComboBoxTokenizer' || ((_d = decorator.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'Tokenizer')
      }, decorator);
    });
  };
  (0, _react.useEffect)(() => {
    var _a;
    setShowValidation(!!(!hideValidationMessage && !!validationMessage && isFocused && ((_a = internalControlRef === null || internalControlRef === void 0 ? void 0 : internalControlRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))));
  }, [hideValidationMessage, isFocused, validationMessage, (_a = global.document) === null || _a === void 0 ? void 0 : _a.activeElement]);
  const anyTailContent = !!helpText || doDecoratorsExist('tailStart') || doDecoratorsExist('tailEnd');
  // We debounce the screenReaderMessage because updating it rapidly leads to repeated
  // announcements. With debouncing we can reasonably skip announcing a stale screenReaderMessage
  const {
    debouncedState: debouncedMessage,
    waiting
  } = (0, _useDebouncedState.useDebouncedState)(screenReaderMessage);
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    id: componentId,
    ref: mergedRef
  }), enableScreenReaderStatus && (/*#__PURE__*/_react.default.createElement("div", {
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}--screen-reader-only`)
  }, !waiting && debouncedMessage)), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, headingProps, {
    className: headingClasses
  }), validationMessage && !screenReaderOnlyLabel && (/*#__PURE__*/_react.default.createElement(_FormFieldDecorator.FormFieldDecorator, {
    position: "headingStart"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    iconName: isInfoIcon(validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state) ? validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state : `messaging-${validationMessage.state}`,
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__icon`, `${CSS_BLOCK}__decorator`, {
      [`${CSS_BLOCK}__info-icon`]: isInfoIcon(validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state)
    })
  }))), renderDecorators('headingStart'), /*#__PURE__*/_react.default.createElement("label", Object.assign({}, labelProps, {
    className: labelClasses,
    htmlFor: inputId
  }), label), required && !disabled && (!readOnly || allowReadonlyRequired) && (/*#__PURE__*/_react.default.createElement(_FormFieldDecorator.FormFieldDecorator, {
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__required`),
    position: "label"
  }, "*")), renderDecorators('label'), doDecoratorsExist('headingEnd') && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__spacer`)
  }), renderDecorators('headingEnd')))), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherControlContainerProps, {
    className: controlContainerClasses
  }), /*#__PURE__*/_react.default.createElement(_ValidationOverlay.ValidationOverlay, Object.assign({}, validationOverlayProps, {
    show: showValidation,
    validationMessage: Object.assign(Object.assign({}, validationMessage), {
      state: isInfoIcon(validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state) ? 'info' : validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state
    }),
    liveRegionClassName: classnames(`${CSS_BLOCK}__live-region`),
    targetClassName: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__overlay`, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.targetClassName)
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherControlProps, {
    className: controlClasses,
    ref: (0, _reactMergeRefs.default)([controlRef, internalControlRef])
  }, describeControl ? {
    'aria-describedby': ((_b = ariaDescribedby.map(element => element.value).join(' ')) === null || _b === void 0 ? void 0 : _b.trim()) || undefined
  } : {}), renderDecorators('inputStart'), renderInput(Object.assign(Object.assign(Object.assign({}, inputProps), {
    isFocused,
    inputClassName: inputClasses
  }), !describeControl ? {
    'aria-describedby': ((_c = ariaDescribedby.map(element => element.value).join(' ')) === null || _c === void 0 ? void 0 : _c.trim()) || undefined
  } : {})), renderDecorators('inputEnd')), renderDecorators('afterInput'))), anyTailContent && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, tailContainerProps, {
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__tail-container`, tailContainerProps === null || tailContainerProps === void 0 ? void 0 : tailContainerProps.className)
  }), renderDecorators('tailStart'), helpText && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, helpTextProps, {
    className: helpClasses,
    id: helpTextId
  }), helpText)), doDecoratorsExist('tailEnd') && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__spacer`)
  }), renderDecorators('tailEnd')))))));
});
FormField.displayName = 'FormField';
var _default = exports.default = FormField;